<template>
  <a-menu
    v-if="$route.name"
    theme="dark"
    mode="horizontal"
    :selected-keys="$route.matched.map(m => m.name)"
    :default-open-keys="$route.matched.map(m => m.name)"
  >
    <component
      :is="menuItem.children ? 'a-sub-menu' : 'a-menu-item'"
      v-for="menuItem in menuItems"
      :key="menuItem.route.name"
    >
      <template v-if="menuItem.children">
        <span slot="title">
          <a-icon :type="menuItem.icon" />
          <span>
            {{ menuItem.title }}
          </span>
        </span>
        <a-menu-item
          v-for="subMenuItem in menuItem.children"
          :key="subMenuItem.route.name"
        >
          <eki-env-link :to="subMenuItem.route">
            <a-icon :type="subMenuItem.icon" />
            <span>{{ subMenuItem.title }}</span>
          </eki-env-link>
        </a-menu-item>
      </template>
      <eki-env-link
        v-else
        :to="menuItem.route"
      >
        <a-icon :type="menuItem.icon" />
        <span>{{ menuItem.title }}</span>
      </eki-env-link>
    </component>
  </a-menu>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'TopMenu',

  props: {
    menuItems: {
      type: Array,
      required: true
    }
  }
})
</script>